import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'seo-bike-bfl',
  templateUrl: './seo-bike-bfl.component.html'
})
export class SeoBikeBflComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    if (document.getElementById('ans1')) { document.getElementById('ans1').style.display = 'none'; }
    if (document.getElementById('ans2')) { document.getElementById('ans2').style.display = 'none'; }
    if (document.getElementById('ans3')) { document.getElementById('ans3').style.display = 'none'; }
    if (document.getElementById('ans4')) { document.getElementById('ans4').style.display = 'none'; }
    if (document.getElementById('ans5')) { document.getElementById('ans5').style.display = 'none'; }
    if (document.getElementById('ans6')) { document.getElementById('ans6').style.display = 'none'; }
    if (document.getElementById('ans7')) { document.getElementById('ans7').style.display = 'none'; }
    if (document.getElementById('ans8')) { document.getElementById('ans8').style.display = 'none'; }
    if (document.getElementById('ans9')) { document.getElementById('ans9').style.display = 'none'; }
    if (document.getElementById('ans10')) { document.getElementById('ans10').style.display = 'none'; }
    if (document.getElementById('ans11')) { document.getElementById('ans11').style.display = 'none'; }
  }

  openAnswer(element) {
    if (element.getElementsByTagName('svg')[0].style.display == "none") {
      element.getElementsByTagName('svg')[0].style.display = "block"
      element.getElementsByTagName('svg')[1].style.display = "none"
      element.nextElementSibling.style.display = 'none';
    } else {
      element.getElementsByTagName('svg')[0].style.display = "none"
      element.getElementsByTagName('svg')[1].style.display = "block"
      element.nextElementSibling.style.display = 'block';
    }
  }
}
